/** Sign out and "finish later" for the company setup modal. */

export const PART_A_LATER_KEY = 'part_a_finish_later';

export function partARedirectPath(needsModal, pathname) {
  if (!needsModal) return null;
  if (pathname === '/dashboard' || pathname === '/logout') return null;
  return '/dashboard';
}

export function partADeferred() {
  try {
    return sessionStorage.getItem(PART_A_LATER_KEY) === '1';
  } catch (err) {
    return false;
  }
}

export function deferPartA() {
  try {
    sessionStorage.setItem(PART_A_LATER_KEY, '1');
  } catch (err) {
    /* storage can be blocked */
  }
}

export function clearPartADeferral() {
  try {
    sessionStorage.removeItem(PART_A_LATER_KEY);
  } catch (err) {
    /* storage can be blocked */
  }
}

export function leaveToLogin(onLogout, assign = (path) => window.location.replace(path)) {
  if (typeof onLogout === 'function') onLogout();
  assign('/login');
}
